// import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
// import ManagementTable from '../../../components/management/ManagementTable.js';
// import { promoCodes } from '../../../constants/mockData/managementMockData';
// import Modal from 'react-bootstrap/Modal';


// class PromoCodes extends Component {
//  constructor(props) {
//    super(props);
//    this.state = {
//      promoCodes: [...promoCodes],
//      showAddModal: false,
//      promoCode: {
//        code: '',
//        type: 'Discount',
//        discountValue: '',
//        expiry: '',
//        usageLimit: '',
//        active: true
//      },
//      error: '',
//      searchTerm: '',
//      statusFilter: 'All'
//    };
//  }


//  _toggleAddModal = () => {
//    this.setState({
//      showAddModal: !this.state.showAddModal,
//      error: '',
//      promoCode: {
//        code: '',
//        type: 'Discount',
//        discountValue: '',
//        expiry: '',
//        usageLimit: '',
//        active: true
//      }
//    });
//  };


//  _handleInputChange = (e) => {
//    const { name, value, type, checked } = e.target;
//    this.setState({
//      promoCode: {
//        ...this.state.promoCode,
//        [name]: type === 'checkbox' ? checked : value
//      }
//    });
//  };


//  _handleFilterChange = (e) => {
//    this.setState({ [e.target.name]: e.target.value });
//  };


//  _handleSave = () => {
//    const { promoCode, promoCodes } = this.state;
  
//    if (!promoCode.code || !promoCode.discountValue) {
//      this.setState({ error: 'Please enter both code and discount value.' });
//      return;
//    }


//    const exists = promoCodes.find(pc => pc.code.toLowerCase() === promoCode.code.toLowerCase());
//    if (exists) {
//      this.setState({ error: 'This promo code already exists. Please use a unique code.' });
//      return;
//    }


//    const newItem = {
//      ...promoCode,
//      id: promoCodes.length + 1,
//      discount: promoCode.type === 'Discount' ? `${promoCode.discountValue}%` : `€${promoCode.discountValue}`,
//      usage: `0 / ${promoCode.usageLimit || '∞'}`,
//      status: promoCode.active ? 'Active' : 'Disabled'
//    };


//    this.setState({
//      promoCodes: [...promoCodes, newItem],
//      showAddModal: false
//    });
//  };


//  _getFilteredData = () => {
//    const { promoCodes, searchTerm, statusFilter } = this.state;
//    return promoCodes.filter(pc => {
//      const matchesSearch = pc.code.toLowerCase().includes(searchTerm.toLowerCase());
//      const matchesStatus = statusFilter === 'All' || pc.status === statusFilter;
//      return matchesSearch && matchesStatus;
//    });
//  };


//  _getColumns = () => [
//    {
//      Header: () => <strong className="header__clr">CODE</strong>,
//      accessor: 'code',
//      Cell: (row) => <span className="text-dark-75 font-weight-bold">{row.value}</span>
//    },
//    {
//      Header: () => <strong className="header__clr">TYPE</strong>,
//      accessor: 'type',
//      Cell: (row) => (
//        <span className={`label label-inline label-light-${row.value === 'Discount' ? 'primary' : 'warning'}`}>
//          {row.value}
//        </span>
//      )
//    },
//    {
//      Header: () => <strong className="header__clr">VALUE</strong>,
//      accessor: 'discount'
//    },
//    {
//      Header: () => <strong className="header__clr">USAGE</strong>,
//      accessor: 'usage'
//    },
//    {
//      Header: () => <strong className="header__clr">EXPIRY</strong>,
//      accessor: 'expiry'
//    },
//    {
//      Header: () => <strong className="header__clr">STATUS</strong>,
//      accessor: 'status',
//      Cell: (row) => (
//        <span className={`label label-inline label-pill ${row.value === 'Active' ? 'label-light-success' : 'label-light-danger'}`}>
//          {row.value}
//        </span>
//      )
//    },
//    {
//      Header: () => <strong className="header__clr">ACTIONS</strong>,
//      sortable: false,
//      Cell: () => (
//        <>
//          <button className="btn btn-icon btn-sm btn-light-primary mr-2">
//            <i className="la la-edit"></i>
//          </button>
//          <button className="btn btn-icon btn-sm btn-light-danger">
//            <i className="la la-trash"></i>
//          </button>
//        </>
//      )
//    }
//  ];


//  render() {
//    const { showAddModal, promoCode } = this.state;


//    return (
//      <div className="container">
//        <ManagementTable
//          title="Promo Codes"
//          columns={this._getColumns()}
//          data={this._getFilteredData()}
//          renderToolbar={() => (
//            <div className="card-toolbar d-flex align-items-center">
//              <div className="input-icon mr-2" style={{ width: '200px' }}>
//                <input
//                  type="text"
//                  className="form-control"
//                  placeholder="Search by code..."
//                  name="searchTerm"
//                  value={this.state.searchTerm}
//                  onChange={this._handleFilterChange}
//                />
//                <span>
//                  <i className="flaticon2-search-1 text-muted"></i>
//                </span>
//              </div>
//              <div className="mr-6" style={{ width: '150px' }}>
//                <select
//                  className="form-control"
//                  name="statusFilter"
//                  value={this.state.statusFilter}
//                  onChange={this._handleFilterChange}
//                >
//                  <option value="All">All Status</option>
//                  <option value="Active">Active</option>
//                  <option value="Disabled">Disabled</option>
//                </select>
//              </div>
//              <button className="btn btn-primary font-weight-bolder" onClick={this._toggleAddModal}>
//                <span className="svg-icon svg-icon-md mr-1">
//                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
//                    <rect x="0" y="0" width="24" height="24" fill="none"/>
//                    <circle fill="#000000" cx="9" cy="15" r="6"/>
//                    <path d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z" fill="#000000" opacity="0.3"/>
//                  </svg>
//                </span>
//                Add Promo Code
//              </button>
//            </div>
//          )}
//        />


//        <Modal show={showAddModal} onHide={this._toggleAddModal}>
//          <Modal.Header closeButton>
//            <Modal.Title>Add Promo Code</Modal.Title>
//          </Modal.Header>
//          <Modal.Body>
//            {this.state.error && (
//              <div className="alert alert-custom alert-light-danger fade show mb-5" role="alert">
//                <div className="alert-text">{this.state.error}</div>
//              </div>
//            )}
//            <div className="form-group">
//              <label>Promo Code</label>
//              <input type="text" className="form-control" name="code" value={promoCode.code} onChange={this._handleInputChange} />
//            </div>
//            <div className="form-group">
//              <label>Type</label>
//              <select className="form-control" name="type" value={promoCode.type} onChange={this._handleInputChange}>
//                <option value="Discount">Discount (% off)</option>
//                <option value="Credit">Credit (Fixed €)</option>
//              </select>
//            </div>
//            <div className="form-group">
//              <label>Value ({promoCode.type === 'Discount' ? '%' : '€'})</label>
//              <input type="number" className="form-control" name="discountValue" value={promoCode.discountValue} onChange={this._handleInputChange} />
//            </div>
//            <div className="form-group">
//              <label>Expiry Date</label>
//              <input type="date" className="form-control" name="expiry" value={promoCode.expiry} onChange={this._handleInputChange} />
//            </div>
//            <div className="form-group">
//              <label>Usage Limit</label>
//              <input type="number" className="form-control" name="usageLimit" value={promoCode.usageLimit} onChange={this._handleInputChange} />
//            </div>
//            <div className="form-group">
//              <label className="checkbox checkbox-outline checkbox-success">
//                <input type="checkbox" name="active" checked={promoCode.active} onChange={this._handleInputChange} />
//                <span></span>
//                Active
//              </label>
//            </div>
//          </Modal.Body>
//          <Modal.Footer>
//            <button className="btn btn-secondary" onClick={this._toggleAddModal}>Cancel</button>
//            <button className="btn btn-primary" onClick={this._handleSave}>Save Promo Code</button>
//          </Modal.Footer>
//        </Modal>
//      </div>
//    );
//  }
// }


// export default withRouter(PromoCodes);














// import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
// import ManagementTable from "../../../components/management/ManagementTable.js";
// import Modal from "react-bootstrap/Modal";

// import {
//   listDiscounts,
//   createDiscount,
//   updateDiscount,
//   deleteDiscount,
// } from "../../../services/discountApi"; // adjust path if needed

// function toYMD(input) {
//   // input from <input type="date" /> is already YYYY-MM-DD
//   if (!input) return null;
//   return input;
// }

// function normalizeType(uiType) {
//   // UI types: "Discount" (percent) or "Credit" (fixed)
//   // Backend types: recommend "percent" and "fixed"
//   return uiType === "Credit" ? "fixed" : "percent";
// }

// function denormalizeType(apiType) {
//   return apiType === "fixed" ? "Credit" : "Discount";
// }

// function formatValue(type, value) {
//   if (value === null || value === undefined || value === "") return "";
//   return type === "Discount" ? `${value}%` : `€${Number(value).toFixed(2)}`;
// }

// function usageText(used, limit) {
//   const lim = limit === null || limit === undefined || limit === "" ? "∞" : limit;
//   const u = used === null || used === undefined ? 0 : used;
//   return `${u} / ${lim}`;
// }

// function statusText(active) {
//   return active ? "Active" : "Disabled";
// }

// export class PromoCodes extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       promoCodes: [],
//       loading: false,

//       showAddModal: false,
//       isEditMode: false,
//       editingId: null,

//       promoCode: {
//         code: "",
//         type: "Discount", // Discount = percent, Credit = fixed
//         discountValue: "",
//         expiry: "",
//         usageLimit: "",
//         active: true,
//       },

//       error: "",
//       searchTerm: "",
//       statusFilter: "All",
//     };
//   }

//   componentDidMount() {
//     this._load();
//   }

//   _load = async () => {
//     this.setState({ loading: true, error: "" });
//     try {
//       // If your API is paginated, you might get { results: [...] }
//       const data = await listDiscounts();

//       const rows = Array.isArray(data) ? data : (data.results || []);
//       const mapped = rows.map((d) => {
//         const type = denormalizeType(d.type);
//         const value = d.value;

//         return {
//           id: d.id,
//           code: d.promo_code,
//           type,
//           value,
//           discount: formatValue(type, value),
//           usage: usageText(d.used_count, d.usage_limit),
//           expiry: d.expiry_date || "",
//           status: statusText(d.active),
//           // keep raw fields for edit
//           _raw: d,
//         };
//       });

//       this.setState({ promoCodes: mapped });
//     } catch (e) {
//       this.setState({ error: e.message || "Failed to load promo codes." });
//     } finally {
//       this.setState({ loading: false });
//     }
//   };

//   _toggleAddModal = () => {
//     this.setState((prev) => ({
//       showAddModal: !prev.showAddModal,
//       isEditMode: false,
//       editingId: null,
//       error: "",
//       promoCode: {
//         code: "",
//         type: "Discount",
//         discountValue: "",
//         expiry: "",
//         usageLimit: "",
//         active: true,
//       },
//     }));
//   };

//   _openEditModal = (row) => {
//     const d = row?._raw || {};
//     const type = denormalizeType(d.type);

//     this.setState({
//       showAddModal: true,
//       isEditMode: true,
//       editingId: d.id,
//       error: "",
//       promoCode: {
//         code: d.promo_code || "",
//         type,
//         discountValue: d.value ?? "",
//         expiry: d.expiry_date || "",
//         usageLimit: d.usage_limit ?? "",
//         active: !!d.active,
//       },
//     });
//   };

//   _handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     this.setState((prev) => ({
//       promoCode: {
//         ...prev.promoCode,
//         [name]: type === "checkbox" ? checked : value,
//       },
//     }));
//   };

//   _handleFilterChange = (e) => {
//     this.setState({ [e.target.name]: e.target.value });
//   };

//   _validateForm = () => {
//     const { promoCode } = this.state;

//     if (!promoCode.code) return "Please enter promo code.";
//     if (promoCode.discountValue === "" || promoCode.discountValue === null) return "Please enter value.";

//     const v = Number(promoCode.discountValue);
//     if (Number.isNaN(v) || v < 0) return "Value must be a valid positive number.";

//     if (promoCode.type === "Discount" && v > 100) return "Percent discount cannot be more than 100.";

//     // optional: expiry format check
//     // optional: usageLimit check
//     if (promoCode.usageLimit !== "" && promoCode.usageLimit !== null) {
//       const ul = Number(promoCode.usageLimit);
//       if (Number.isNaN(ul) || ul < 0) return "Usage limit must be a positive number or empty.";
//     }

//     return "";
//   };

//   _handleSave = async () => {
//     const formError = this._validateForm();
//     if (formError) {
//       this.setState({ error: formError });
//       return;
//     }

//     const { promoCode, isEditMode, editingId } = this.state;

//     const payload = {
//       promo_code: String(promoCode.code).trim().toUpperCase(),
//       type: normalizeType(promoCode.type), // percent/fixed
//       value: Number(promoCode.discountValue),
//       expiry_date: toYMD(promoCode.expiry), // YYYY-MM-DD
//       usage_limit: promoCode.usageLimit === "" ? null : Number(promoCode.usageLimit),
//       active: !!promoCode.active,
//     };

//     this.setState({ loading: true, error: "" });

//     try {
//       if (isEditMode && editingId) {
//         await updateDiscount(editingId, payload);
//       } else {
//         await createDiscount(payload);
//       }

//       // refresh list
//       await this._load();
//       this.setState({ showAddModal: false });
//     } catch (e) {
//       this.setState({ error: e.message || "Failed to save promo code." });
//     } finally {
//       this.setState({ loading: false });
//     }
//   };

//   _handleDelete = async (row) => {
//     const id = row?._raw?.id;
//     const code = row?.code;

//     if (!id) return;

//     // keep it simple; if you already have a confirm modal, use that instead
//     // eslint-disable-next-line no-alert
//     const ok = window.confirm(`Delete promo code "${code}"?`);
//     if (!ok) return;

//     this.setState({ loading: true, error: "" });
//     try {
//       await deleteDiscount(id);
//       await this._load();
//     } catch (e) {
//       this.setState({ error: e.message || "Failed to delete promo code." });
//     } finally {
//       this.setState({ loading: false });
//     }
//   };

//   _getFilteredData = () => {
//     const { promoCodes, searchTerm, statusFilter } = this.state;
//     return promoCodes.filter((pc) => {
//       const matchesSearch = pc.code.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesStatus = statusFilter === "All" || pc.status === statusFilter;
//       return matchesSearch && matchesStatus;
//     });
//   };

//   _getColumns = () => [
//     {
//       Header: () => <strong className="header__clr">CODE</strong>,
//       accessor: "code",
//       Cell: (row) => <span className="text-dark-75 font-weight-bold">{row.value}</span>,
//     },
//     {
//       Header: () => <strong className="header__clr">TYPE</strong>,
//       accessor: "type",
//       Cell: (row) => (
//         <span className={`label label-inline label-light-${row.value === "Discount" ? "primary" : "warning"}`}>
//           {row.value}
//         </span>
//       ),
//     },
//     {
//       Header: () => <strong className="header__clr">VALUE</strong>,
//       accessor: "discount",
//     },
//     {
//       Header: () => <strong className="header__clr">USAGE</strong>,
//       accessor: "usage",
//     },
//     {
//       Header: () => <strong className="header__clr">EXPIRY</strong>,
//       accessor: "expiry",
//     },
//     {
//       Header: () => <strong className="header__clr">STATUS</strong>,
//       accessor: "status",
//       Cell: (row) => (
//         <span
//           className={`label label-inline label-pill ${
//             row.value === "Active" ? "label-light-success" : "label-light-danger"
//           }`}
//         >
//           {row.value}
//         </span>
//       ),
//     },
//     {
//       Header: () => <strong className="header__clr">ACTIONS</strong>,
//       sortable: false,
//       Cell: (row) => {
//         const original = row?.original;
//         return (
//           <>
//             <button
//               className="btn btn-icon btn-sm btn-light-primary mr-2"
//               onClick={() => this._openEditModal(original)}
//               type="button"
//             >
//               <i className="la la-edit"></i>
//             </button>
//             <button
//               className="btn btn-icon btn-sm btn-light-danger"
//               onClick={() => this._handleDelete(original)}
//               type="button"
//             >
//               <i className="la la-trash"></i>
//             </button>
//           </>
//         );
//       },
//     },
//   ];

//   render() {
//     const { showAddModal, promoCode, loading, error, isEditMode } = this.state;

//     return (
//       <div className="container">
//         {error && !showAddModal && (
//           <div className="alert alert-custom alert-light-danger fade show mb-5" role="alert">
//             <div className="alert-text">{error}</div>
//           </div>
//         )}

//         <ManagementTable
//           title="Promo Codes"
//           columns={this._getColumns()}
//           data={this._getFilteredData()}
//           loading={loading}
//           renderToolbar={() => (
//             <div className="card-toolbar d-flex align-items-center">
//               <div className="input-icon mr-2" style={{ width: "200px" }}>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search by code..."
//                   name="searchTerm"
//                   value={this.state.searchTerm}
//                   onChange={this._handleFilterChange}
//                 />
//                 <span>
//                   <i className="flaticon2-search-1 text-muted"></i>
//                 </span>
//               </div>

//               <div className="mr-6" style={{ width: "150px" }}>
//                 <select
//                   className="form-control"
//                   name="statusFilter"
//                   value={this.state.statusFilter}
//                   onChange={this._handleFilterChange}
//                 >
//                   <option value="All">All Status</option>
//                   <option value="Active">Active</option>
//                   <option value="Disabled">Disabled</option>
//                 </select>
//               </div>

//               <button className="btn btn-primary font-weight-bolder" onClick={this._toggleAddModal} type="button">
//                 <span className="svg-icon svg-icon-md mr-1">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
//                     <rect x="0" y="0" width="24" height="24" fill="none" />
//                     <circle fill="#000000" cx="9" cy="15" r="6" />
//                     <path
//                       d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z"
//                       fill="#000000"
//                       opacity="0.3"
//                     />
//                   </svg>
//                 </span>
//                 Add Promo Code
//               </button>
//             </div>
//           )}
//         />

//         <Modal show={showAddModal} onHide={this._toggleAddModal}>
//           <Modal.Header closeButton>
//             <Modal.Title>{isEditMode ? "Edit Promo Code" : "Add Promo Code"}</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {error && (
//               <div className="alert alert-custom alert-light-danger fade show mb-5" role="alert">
//                 <div className="alert-text">{error}</div>
//               </div>
//             )}

//             <div className="form-group">
//               <label>Promo Code</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 name="code"
//                 value={promoCode.code}
//                 onChange={this._handleInputChange}
//                 disabled={isEditMode} // optional: lock code on edit
//               />
//             </div>

//             <div className="form-group">
//               <label>Type</label>
//               <select className="form-control" name="type" value={promoCode.type} onChange={this._handleInputChange}>
//                 <option value="Discount">Discount (% off)</option>
//                 <option value="Credit">Credit (Fixed €)</option>
//               </select>
//             </div>

//             <div className="form-group">
//               <label>Value ({promoCode.type === "Discount" ? "%" : "€"})</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="discountValue"
//                 value={promoCode.discountValue}
//                 onChange={this._handleInputChange}
//               />
//             </div>

//             <div className="form-group">
//               <label>Expiry Date</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 name="expiry"
//                 value={promoCode.expiry}
//                 onChange={this._handleInputChange}
//               />
//             </div>

//             <div className="form-group">
//               <label>Usage Limit</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 name="usageLimit"
//                 value={promoCode.usageLimit}
//                 onChange={this._handleInputChange}
//               />
//             </div>

//             <div className="form-group">
//               <label className="checkbox checkbox-outline checkbox-success">
//                 <input type="checkbox" name="active" checked={promoCode.active} onChange={this._handleInputChange} />
//                 <span></span>
//                 Active
//               </label>
//             </div>
//           </Modal.Body>

//           <Modal.Footer>
//             <button className="btn btn-secondary" onClick={this._toggleAddModal} type="button">
//               Cancel
//             </button>
//             <button className="btn btn-primary" onClick={this._handleSave} type="button" disabled={loading}>
//               {loading ? "Saving..." : "Save Promo Code"}
//             </button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     );
//   }
// }

// export default withRouter(PromoCodes);








import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ManagementTable from "../../../components/management/ManagementTable.js";
import Modal from "react-bootstrap/Modal";
import Backend from "../../../utils/Backend.js"; // adjust path if different

class PromoCodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoCodes: [],
      loading: false,
      showAddModal: false,
      isEditing: false,
      editingId: null,
      promoCode: {
        promo_code: "",
        type: "PERCENT", // match backend enum if you have one
        value: "",
        expiry_date: "",
        usage_limit: "",
        active: true,
      },
      error: "",
      searchTerm: "",
      statusFilter: "All",
    };
  }

  componentDidMount() {
    this._loadPromoCodes();
  }

  _loadPromoCodes = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await Backend.getDiscounts();

      // If your API returns paginated {results: []} handle it:
      const rows = Array.isArray(res) ? res : res.results || [];

      this.setState({ promoCodes: rows, loading: false });
    } catch (e) {
      this.setState({
        loading: false,
        error: `Failed to load promo codes. ${e?.message || ""}`,
      });
    }
  };

  _resetForm = () => ({
    promo_code: "",
    type: "PERCENT",
    value: "",
    expiry_date: "",
    usage_limit: "",
    active: true,
  });

  _toggleAddModal = () => {
    this.setState((prev) => ({
      showAddModal: !prev.showAddModal,
      isEditing: false,
      editingId: null,
      error: "",
      promoCode: this._resetForm(),
    }));
  };

  _openEditModal = (row) => {
    const d = row.original; // react-table row object
    this.setState({
      showAddModal: true,
      isEditing: true,
      editingId: d.id,
      error: "",
      promoCode: {
        promo_code: d.promo_code || "",
        type: d.type || "PERCENT",
        value: d.value ?? "",
        expiry_date: d.expiry_date || "", // ensure backend returns yyyy-mm-dd
        usage_limit: d.usage_limit ?? "",
        active: !!d.active,
      },
    });
  };

  _handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      promoCode: {
        ...this.state.promoCode,
        [name]: type === "checkbox" ? checked : value,
      },
    });
  };

  _handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _handleSave = async () => {
    const { promoCode, isEditing, editingId } = this.state;

    if (!promoCode.promo_code || promoCode.value === "" || promoCode.value === null) {
      this.setState({ error: "Please enter promo code and value." });
      return;
    }

    // Build payload exactly as backend expects
    const payload = {
      promo_code: promoCode.promo_code.trim(),
      type: promoCode.type,
      value: Number(promoCode.value),
      expiry_date: promoCode.expiry_date || null,
      usage_limit: promoCode.usage_limit === "" ? null : Number(promoCode.usage_limit),
      active: !!promoCode.active,
    };

    try {
      this.setState({ loading: true, error: "" });

      if (isEditing) {
        await Backend.updateDiscount(editingId, payload);
      } else {
        await Backend.createDiscount(payload);
      }

      this.setState({ showAddModal: false, loading: false });
      await this._loadPromoCodes();
    } catch (e) {
      this.setState({
        loading: false,
        error: `Save failed. ${e?.message || ""}`,
      });
    }
  };

  _handleDelete = async (row) => {
    const d = row.original;
    const ok = window.confirm(`Delete promo code "${d.promo_code}"?`);
    if (!ok) return;

    try {
      this.setState({ loading: true, error: "" });
      await Backend.deleteDiscount(d.id);
      this.setState({ loading: false });
      await this._loadPromoCodes();
    } catch (e) {
      this.setState({
        loading: false,
        error: `Delete failed. ${e?.message || ""}`,
      });
    }
  };

  _formatValue = (d) => {
    // If you store type as PERCENT / FIXED:
    if (d.type === "PERCENT") return `${d.value}%`;
    return `€${Number(d.value || 0).toFixed(2)}`;
  };

  _formatUsage = (d) => {
    const used = d.used_count ?? 0;
    const limit = d.usage_limit ?? "∞";
    return `${used} / ${limit}`;
  };

  _statusLabel = (d) => (d.active ? "Active" : "Disabled");

  _getFilteredData = () => {
    const { promoCodes, searchTerm, statusFilter } = this.state;

    return promoCodes
      .map((d) => ({
        ...d,
        discount: this._formatValue(d),
        usage: this._formatUsage(d),
        expiry: d.expiry_date || "-",
        status: this._statusLabel(d),
      }))
      .filter((pc) => {
        const matchesSearch = String(pc.promo_code || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === "All" || pc.status === statusFilter;
        return matchesSearch && matchesStatus;
      });
  };

  _getColumns = () => [
    {
      Header: () => <strong className="header__clr">CODE</strong>,
      accessor: "promo_code",
      Cell: (row) => (
        <span className="text-dark-75 font-weight-bold">{row.value}</span>
      ),
    },
    {
      Header: () => <strong className="header__clr">TYPE</strong>,
      accessor: "type",
      Cell: (row) => (
        <span
          className={`label label-inline label-light-${
            row.value === "PERCENT" ? "primary" : "warning"
          }`}
        >
          {row.value === "PERCENT" ? "Discount (% off)" : "Credit (Fixed €)"}
        </span>
      ),
    },
    {
      Header: () => <strong className="header__clr">VALUE</strong>,
      accessor: "discount",
    },
    {
      Header: () => <strong className="header__clr">USAGE</strong>,
      accessor: "usage",
    },
    {
      Header: () => <strong className="header__clr">EXPIRY</strong>,
      accessor: "expiry",
    },
    {
      Header: () => <strong className="header__clr">STATUS</strong>,
      accessor: "status",
      Cell: (row) => (
        <span
          className={`label label-inline label-pill ${
            row.value === "Active"
              ? "label-light-success"
              : "label-light-danger"
          }`}
        >
          {row.value}
        </span>
      ),
    },
    {
      Header: () => <strong className="header__clr">ACTIONS</strong>,
      sortable: false,
      Cell: (row) => (
        <>
          <button
            className="btn btn-icon btn-sm btn-light-primary mr-2"
            onClick={() => this._openEditModal(row)}
            type="button"
          >
            <i className="la la-edit"></i>
          </button>
          <button
            className="btn btn-icon btn-sm btn-light-danger"
            onClick={() => this._handleDelete(row)}
            type="button"
          >
            <i className="la la-trash"></i>
          </button>
        </>
      ),
    },
  ];

  render() {
    const { showAddModal, promoCode, loading, isEditing } = this.state;

    return (
      <div className="container">
        <ManagementTable
          title="Promo Codes"
          columns={this._getColumns()}
          data={this._getFilteredData()}
          loading={loading}
          renderToolbar={() => (
            <div className="card-toolbar d-flex align-items-center">
              <div className="input-icon mr-2" style={{ width: "200px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by code..."
                  name="searchTerm"
                  value={this.state.searchTerm}
                  onChange={this._handleFilterChange}
                />
                <span>
                  <i className="flaticon2-search-1 text-muted"></i>
                </span>
              </div>

              <div className="mr-6" style={{ width: "150px" }}>
                <select
                  className="form-control"
                  name="statusFilter"
                  value={this.state.statusFilter}
                  onChange={this._handleFilterChange}
                >
                  <option value="All">All Status</option>
                  <option value="Active">Active</option>
                  <option value="Disabled">Disabled</option>
                </select>
              </div>

              <button
                className="btn btn-primary font-weight-bolder"
                onClick={this._toggleAddModal}
                type="button"
              >
                Add Promo Code
              </button>
            </div>
          )}
        />

        <Modal show={showAddModal} onHide={this._toggleAddModal}>
          <Modal.Header closeButton>
            <Modal.Title>{isEditing ? "Edit Promo Code" : "Add Promo Code"}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.error && (
              <div
                className="alert alert-custom alert-light-danger fade show mb-5"
                role="alert"
              >
                <div className="alert-text">{this.state.error}</div>
              </div>
            )}

            <div className="form-group">
              <label>Promo Code</label>
              <input
                type="text"
                className="form-control"
                name="promo_code"
                value={promoCode.promo_code}
                onChange={this._handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Type</label>
              <select
                className="form-control"
                name="type"
                value={promoCode.type}
                onChange={this._handleInputChange}
              >
                <option value="PERCENT">Discount (% off)</option>
                <option value="FIXED">Credit (Fixed €)</option>
              </select>
            </div>

            <div className="form-group">
              <label>Value ({promoCode.type === "PERCENT" ? "%" : "€"})</label>
              <input
                type="number"
                className="form-control"
                name="value"
                value={promoCode.value}
                onChange={this._handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Expiry Date</label>
              <input
                type="date"
                className="form-control"
                name="expiry_date"
                value={promoCode.expiry_date || ""}
                onChange={this._handleInputChange}
              />
            </div>

            <div className="form-group">
              <label>Usage Limit</label>
              <input
                type="number"
                className="form-control"
                name="usage_limit"
                value={promoCode.usage_limit}
                onChange={this._handleInputChange}
              />
              <small className="text-muted">Leave blank for unlimited</small>
            </div>

            <div className="form-group">
              <label className="checkbox checkbox-outline checkbox-success">
                <input
                  type="checkbox"
                  name="active"
                  checked={promoCode.active}
                  onChange={this._handleInputChange}
                />
                <span></span>
                Active
              </label>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button className="btn btn-secondary" onClick={this._toggleAddModal} type="button">
              Cancel
            </button>
            <button className="btn btn-primary" onClick={this._handleSave} type="button">
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(PromoCodes);
